function _templateObject() {
  var data = _taggedTemplateLiteral(["\n       ", "\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { css } from 'styled-components';
import { mediaSmDown } from "../helpers/media";
export var getBaseIndent = function getBaseIndent(theme) {
  return theme.baseIndent;
};
export var getMultipliedIndent = function getMultipliedIndent(theme, coefficient) {
  return "".concat(getBaseIndent(theme) * coefficient, "px");
};
export var getMargin = function getMargin(theme, value) {
  return value === true ? 'auto' : getMultipliedIndent(theme, value);
};
export var getTypography = function getTypography(theme) {
  return theme.typography;
};
export var getTypographyMobile = function getTypographyMobile(theme) {
  return theme.typographyMobile;
};
export var getTypographyFontSizeStyles = function getTypographyFontSizeStyles(theme, size) {
  return " font-size: ".concat(getTypography(theme)[size].fontSize, ";");
};
export var getTypographyFontStyle = function getTypographyFontStyle() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 300;
  return function (_ref) {
    var theme = _ref.theme;
    return "\n    font-size: ".concat(getTypography(theme)[size].fontSize, ";\n    line-height: ").concat(getTypography(theme)[size].lineHeight, ";\n  ");
  };
};
export var getTypographyFontStyleMobile = function getTypographyFontStyleMobile() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 300;
  return function (_ref2) {
    var theme = _ref2.theme;
    return "\n    font-size: ".concat(getTypographyMobile(theme)[size].fontSize, ";\n    line-height: ").concat(getTypographyMobile(theme)[size].lineHeight, ";\n  ");
  };
};
export var getTypographyFontSize = function getTypographyFontSize() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 300;
  return css(["", " ", ""], getTypographyFontStyle(size), mediaSmDown(_templateObject(), getTypographyFontStyleMobile(size)));
};
export var getBreakpoints = function getBreakpoints(theme) {
  return theme.breakpoints;
};
export var getContainerIndents = function getContainerIndents(theme) {
  return theme.container.indent;
};
export var getContainerMaxWidth = function getContainerMaxWidth(theme) {
  return theme.container.maxWidth;
};
export var getGridSize = function getGridSize(theme) {
  return theme.gridSize;
};
export var getGutterWidth = function getGutterWidth(theme) {
  return theme.gutterWidth;
};